/**
 * Amikor a DOM már elérhető, akkor hívja meg a callbacket.
 * Az onReady és az onContentLoaded közötti különbségért lásd a README-t!
 * Leírásért lásd README!
 * @param callback - A meghívandó callback.
 */
export default function onContentLoaded (callback: TVoidCallback): void {
  document.addEventListener('DOMContentLoaded', callback)
}
